module.exports = __webpack_public_path__ + "e4861095f89f64ba08063920b26faa5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/29_PROP_09.png
// module id = 129
// module chunks = 0